<template>
  <div class="page sign-record-page">
    <div class="ledger-hero">
      <div>
        <div class="section-kicker">SIGN RECORD</div>
        <h1>签约达标记录</h1>
      </div>
      <div class="hero-amount">
        <span>签约日期</span>
        <b>{{ home.signDate || '-' }}</b>
      </div>
    </div>

    <div class="card empty-state" v-if="!home.hasSigned"><h3>当前没有有效签约设备</h3><p>设备解约后，当前签约权益和达标进度已终止；历史协议与支付证据仍由后台留档。</p><button class="btn" @click="$router.push('/')">返回首页</button></div>
    <div class="ledger-summary" v-else>
      <div class="summary-card">
        <span>待提现</span>
        <b>¥{{ money(home.signedAmount || home.withdrawable || 0) }}</b>
      </div>
      <div class="summary-card unlocked">
        <span>已达标</span>
        <b>{{ money(home.achievedAmount || home.pending || 0) }}/780</b>
        <em>达标每月+32.5</em>
      </div>
      <div class="summary-card paid">
        <span>已提现</span>
        <b>¥{{ money(home.paid || 0) }}</b>
      </div>
    </div>

    <div class="card month-card">
      <div class="section-kicker">24 MONTHS</div>
      <h3>24个月达标进度</h3>
      <div class="month-grid">
        <div v-for="i in 24" :key="i" :class="['month-box', monthStatus(i)]">
          <strong>{{ i }}</strong>
          <span>{{ monthLabel(i) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api, getUserId } from '../api'
export default {
  data:()=>({home:{},rows:[],refreshing:false,lastRefresh:'',monthlyOnlineMinutes:0,monthlyRequiredMinutes:1440,refreshTimer:null}),
  computed:{deviceSn(){return this.home.device&&this.home.device.sn},onlineHours(){return (Number(this.monthlyOnlineMinutes||0)/60).toFixed(1).replace('.0','')},requiredHours(){return (Number(this.monthlyRequiredMinutes||1440)/60).toFixed(1).replace('.0','')},progressPercent(){return Math.min(100,Math.round(Number(this.monthlyOnlineMinutes||0)/Number(this.monthlyRequiredMinutes||1440)*100))}},
  async created(){
    await this.load();await this.refresh();this.refreshTimer=setInterval(this.refresh,60000);document.addEventListener('visibilitychange',this.onVisible)
  },
  beforeDestroy(){clearInterval(this.refreshTimer);document.removeEventListener('visibilitychange',this.onVisible)},
  methods:{
    async load(){const userId=getUserId();this.home=(await api.get('/h5/home',{params:{userId}})).data.data;this.rows=(await api.get('/h5/ledger',{params:{userId}})).data.data||[]},
    async refresh(){if(this.refreshing||!this.deviceSn)return;this.refreshing=true;try{const x=(await api.post('/h5/dashboard/refresh',{},{params:{includeLedger:true}})).data.data||{};this.lastRefresh=x.refreshedAt||'';this.monthlyOnlineMinutes=Number(x.monthlyOnlineMinutes||0);this.monthlyRequiredMinutes=Number(x.monthlyRequiredMinutes||1440);await this.load()}catch(e){}finally{this.refreshing=false}},
    onVisible(){if(document.visibilityState==='visible')this.refresh()},
    money(v){return Number(v||0).toFixed(2).replace('.00','')},
    monthStatus(i){
      if(!this.home.hasSigned) return 'pending'
      if(this.home.interrupted) return 'failed'
      return i <= Math.max(1, Number(this.home.qualifiedMonths || 0)) ? 'ok' : 'pending'
    },
    monthLabel(i){
      if(!this.home.hasSigned) return '未达标'
      if(this.home.interrupted) return '取消'
      if(i===1)return '已达标'
      return i <= Math.max(1, Number(this.home.qualifiedMonths || 0)) ? '已达标' : '未达标'
    }
  }
}
</script>
<style scoped>
.ledger-hero{background:linear-gradient(135deg,#102f27,#0fa665 64%,#86e7bb);border-radius:28px;padding:32px;color:#fff;display:flex;justify-content:space-between;align-items:center;margin-bottom:18px;box-shadow:0 24px 62px rgba(15,118,77,.22);overflow:hidden}.ledger-hero h1{font-size:36px;margin:8px 0}.ledger-hero p{color:rgba(255,255,255,.86);margin:0;line-height:1.7}.hero-amount{background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.28);border-radius:22px;padding:18px 22px;text-align:center}.hero-amount span{display:block;color:rgba(255,255,255,.8);font-size:13px}.hero-amount b{font-size:22px}
.ledger-summary{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px;margin-bottom:16px}.summary-card{background:rgba(255,255,255,.9);border-radius:22px;padding:20px;border:1px solid rgba(255,255,255,.8);box-shadow:0 18px 45px rgba(23,53,43,.08)}.summary-card span{display:block;color:#667873;font-size:13px}.summary-card b{display:block;margin:8px 0 6px;font-size:30px}.summary-card em{font-style:normal;color:#82908b;font-size:12px}.summary-card.unlocked b{color:#0fa665}.summary-card.paid b{color:#116d4b}
.rule-card p{color:#52625d;line-height:1.8}.danger-text{color:#d84232!important;background:#fff1ef;border-radius:12px;padding:10px 12px}
.month-grid{display:grid;grid-template-columns:repeat(8,minmax(0,1fr));gap:10px}.month-box{border-radius:18px;padding:13px 8px;text-align:center;border:1px solid #e1eee8;background:#f8fbfa}.month-box strong{display:block;font-size:20px}.month-box span{display:block;margin-top:6px;font-size:12px;color:#6e7c77}.month-box.ok{background:#d5f5e6;border-color:#73cfa6;color:#087447;box-shadow:inset 0 0 0 1px rgba(8,116,71,.08)}.month-box.ok strong{color:#006b3f}.month-box.ok span{color:#075f3d;font-weight:600}.month-box.pending{background:#f7faf8;color:#8a9692}.month-box.failed{background:#fff1ef;border-color:#ffd0cb;color:#d84232}
.live-progress{margin-top:14px;background:#f3faf6;border-radius:14px;padding:13px}.live-progress span,.live-progress b{display:block}.live-progress span{font-size:12px;color:#74837d}.live-progress b{margin:7px 0}.live-progress div{height:8px;background:#dfeae5;border-radius:99px;overflow:hidden}.live-progress i{display:block;height:100%;background:#0fa665;border-radius:99px;transition:width .3s}
@media(max-width:768px){.ledger-hero{display:block;border-radius:20px;padding:20px}.ledger-hero h1{font-size:26px}.hero-amount{text-align:left;margin-top:14px}.ledger-summary{grid-template-columns:1fr;gap:10px}.summary-card{padding:16px;border-radius:18px}.summary-card b{font-size:26px}.month-grid{grid-template-columns:repeat(4,minmax(0,1fr));gap:8px}.month-box{border-radius:14px;padding:10px 4px}.month-box strong{font-size:18px}.month-box span{font-size:11px}}
</style>
